module.exports = __webpack_public_path__ + "img/icons-fill-teams.595c0502.svg";